"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyTip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var i18n_1 = require("../i18n");
var config_context_1 = require("../_util/config-context");
exports.EmptyTip = react_1.default.forwardRef(function EmptyTip(props, ref) {
    var classPrefix = config_context_1.useConfig().classPrefix;
    var t = i18n_1.useTranslation();
    var _a = props.emptyText, emptyText = _a === void 0 ? t.emptyText : _a, className = props.className, restProps = tslib_1.__rest(props, ["emptyText", "className"]);
    return (react_1.default.createElement("span", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-action-state", className) }, restProps), typeof emptyText === "string" ? (react_1.default.createElement("span", { className: classPrefix + "-action-state__text", title: emptyText }, emptyText)) : (emptyText)));
});
exports.EmptyTip.displayName = "EmptyTip";
//# sourceMappingURL=EmptyTip.js.map